<template>
  <v-sheet>
    <v-dialog
      v-model="promptDeleteDashboard"
      max-width="450"
    >
      <dashboard-delete />
    </v-dialog>
  </v-sheet>
</template>

<script>
import DashboardMixin from 'src/dashboard/store/utils/dashboard-mixin'

export default {
  name: 'DashboardModals',
  components: {
    DashboardDelete: () => import('src/dashboard/components/DashboardDelete'),
  },
  mixins: [
    DashboardMixin,
  ],
}
</script>
